import React from 'react';
import d14 from './Card.module.css';
function Card({className,children}){
    return <div className={d14.card+' '+className}>{children}</div>;
     //use .children prop or else the component will swallow any content inside it
}

export default Card;